import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon3dBoxBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-Icon3dBoxBottom"><Path d="M20.6592 18.1543L12 23.1543L3.33984 18.1543L12 13.1543L20.6592 18.1543ZM11 11.4219L2.33984 16.4219V6.42285L11 1.42383V11.4219ZM21.6602 6.42285V16.4219L13 11.4219V1.42383L21.6602 6.42285Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon3dBoxBottom;
